import { render, staticRenderFns } from "./ProductConfigurationEditor.vue?vue&type=template&id=33f36c37&scoped=true"
import script from "./ProductConfigurationEditor.vue?vue&type=script&lang=js"
export * from "./ProductConfigurationEditor.vue?vue&type=script&lang=js"
import style0 from "./ProductConfigurationEditor.vue?vue&type=style&index=0&id=33f36c37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f36c37",
  null
  
)

export default component.exports